import axios from "axios";
import { clearRestaurantCache } from "../../Functionalities/restaurantCache";
import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import MainHeader from "../../CoreComponents/MainHeader";
import NavBar from "../../CoreComponents/NavBar";
import {
  is_shop_admin,
  is_shop_manager,
  protocol,
  url,
  works_in_franchise,
} from "../../Functionalities/Config";
import {
  ManageRestaurant,
  showMessage,
  formatTime,
  ManageProducts,
  getToken,
  excludeArrayFromArray,
  handleImageError,
  getNext3amIST,
} from "../../Functionalities/Functions";
import {
  ManageBalanceAmount,
  ManageRestaurantImage,
  ManageBlock,
  ManageActive,
  ManageWallet,
} from "./Logic";
import { confirmAlert } from "react-confirm-alert"; // Import
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css
import EditTopComponent from "../../CoreComponents/EditTopComponent";
import FilterComponent from "../../CoreComponents/FilterComponent";
import ProductsList from "../../CoreComponents/ProductsList";
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import NoDataComponent from "../../CoreComponents/NoDataComponent";
import { googleApiKey } from "../../Functionalities/Config";
import { validateEmail } from "../../Functionalities/Validation";
import { ManageSettingsAdmin } from "../Franchise/Logic";
import RestaurantStatsCard from "./Components/RestaurantStatsCard";
import RestaurantEditForm from "./Components/RestaurantEditForm";
import RestaurantGallery from "./Components/RestaurantGallery";
import RestaurantChargesSection from "./Components/RestaurantChargesSection";
import RestaurantWalletCard from "./Components/RestaurantWalletCard";
import RestaurantOrderHistory from "./Components/RestaurantOrderHistory";
import { DAY_COMPLETED, basisParam, useRefetchOnBasis } from "../../Functionalities/dayBasis";

function Body(props) {
  const [basis, setBasis] = useState(DAY_COMPLETED);
  let id = props.restaurant;

  const [loading, setLoading] = useState(true);
  const [edit, setEdit] = useState(false);
  const [commission, setCommission] = useState({
    branch_id: "",
    commission: "",
  });
  const [coordOb, setCoordObj] = useState({
    latitude: "",
    longitude: "",
    address: "",
  });

  const [filter, setfilter] = useState({
    from_date: "",
    to_date: "",
    payment_transaction_status: "",
    status: ["COMPLETED", "CUSTOMER_DROPED", "DELIVERY_BOY_DROPED"],
  });

  const [data, setData] = useState({
    id: "",
    branch_name: "",
    mobile: "",
    email: "",
    fssai: "",
    place: "",
    radius: "",
    available_radius: "",
    self_pickup: false,
    self_pickup_restaurent_charge: "",
    pure_veg: false,
    is_celebration_store: false,
    is_cake_store: false,
    free_delivery: false,
    latitude: "",
    longitude: "",
    address: "",
    description: "",
    is_featured: false,
    images: [],
    latestImage: [],
    manager: [],
    adminEdit: false,
    admin_id: "",
    admin_name: "",
    admin_username: "",
    admin_password: "",
    confirm_admin_password: "",
    admin_mobile: "",
    opening_time: "",
    closing_time: "",
    is_block: false,
    time_to_cook: "",
    expence_meter: "",
    is_closed: false,
    restaurent_charge: "",
    base_delivery_charge: "",
    gst_charge: "",
    extra_commission: "",
  });

  const [producttsdata, setproducttsData] = useState({
    id: "",
    name: "",
    data: [],
  });
  const [next, setNext] = useState("");
  const [prev, setPrev] = useState("");
  const [reload, setReload] = useState(false);
  const [stock, setStock] = useState({
    out_of_stock: "",
    item_id: "",
  });
  const [swipe, setswipe] = useState(false);
  const [branchAmounts, setBranchAmounts] = useState({
    completed: 0,
    pending: 0,
    processing: 0,
  });
  const [orderReportSummary, setOrderReportSummary] = useState([]);
  const [reportNext, setReportNext] = useState();
  const [reportPrev, setReportPrev] = useState();

  const [balanceAmount, setBalanceAmount] = useState();
  const [compression, setCompression] = useState(true);
  const [apiKey, setapiKey] = useState(null);
  const [balance, setBalance] = useState({
    branch_id: "",
    amount: "",
    mode_of_payment: "",
    discription: "",
  });

  useEffect(() => {
    getData();
    getProducts();
    getWallet();
    getOrderReportSummary();
    getApiKey();
  }, []);

  useRefetchOnBasis(basis, () => {
    getWallet();
    getOrderReportSummary();
  });

  const getWallet = () => {
    let result = ManageWallet(
      "",
      "",
      "get",
      `order_status_lst=${JSON.stringify(
        filter.status,
      )}&branch_id=${id}&account_amounts=true&from_date=${
        filter.from_date
      }&to_date=${filter.to_date}${basisParam(basis)}`,
    );
    result
      .then((result) => {
        setBranchAmounts({
          ...branchAmounts,
          completed: result.data[0].BRANCH_DUE_AMOUNT.completed,
          pending: result.data[0].BRANCH_DUE_AMOUNT.pending,
          processing: result.data[0].BRANCH_DUE_AMOUNT.processing,
        });
      })
      .catch((err) => {
      });
  };

  const getOrderReportSummary = () => {
    let array = [
      "transaction_type",
      "order_type",
      "promocode_type",
      "in_profit",
      "to_franchise_tstatus",
      "to_admin_tstatus",
      "amount",
      "franchise_charge",
      "restaurent_charge",
      "delivery_charge",
      "wallet_amount_used",
      "offer_discount",
      "promocode_discount",
      "total_food_amount",
      "grand_total",
      "franchise_collected_amount",
      "commission_on_restaurent",
      "commission_amount_on_restaurent",
      "commission_on_franchise",
      "commission_amount_on_franchise",
      "refund_amount",
      "incentive",
      "delivery_boy_earn",
      "franchise_net_balance",
      "amount_credited",
      "amount_debited",
      "franchise",
      "branch",
      "user_of_intrest",
      "delivery_boy",
      "mode_of_payment",
    ];

    let newParams =
      `order_status_lst=${JSON.stringify(
        filter.status,
      )}&branch_id=${id}&from_date=${filter.from_date}&to_date=${
        filter.to_date
      }&payment_transaction_status=${
        filter.payment_transaction_status
      }${basisParam(basis)}&ex_list=` +
      JSON.stringify(
        excludeArrayFromArray(["exlist defined in function"], array),
      );
    let result = ManageWallet("", "", "get", newParams);
    result
      .then((result) => {
        setOrderReportSummary(result.data.results);
        setReportNext(result.data.next);
        setReportPrev(result.data.previous);
      })
      .catch((err) => {
      });
  };

  const handleReportPrev = () => {
    let config = {
      method: "get",
      url: reportPrev.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        setOrderReportSummary(response.data.results);
        setReportNext(response.data.next);
        setReportPrev(response.data.previous);
      })
      .catch(function (error) {});
  };

  const handleReportNext = () => {
    let config = {
      method: "get",
      url: reportNext.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };

    axios(config)
      .then(function (response) {
        setOrderReportSummary(response.data.results);
        setReportNext(response.data.next);
        setReportPrev(response.data.previous);
      })
      .catch(function (error) {});
  };

  let paramsPro = `my_branch=true&for_dropdown=false&branch_id=${id}`;

  const getProducts = () => {
    let result = ManageProducts("", "", "get", paramsPro);
    result
      .then((result) => {
        setproducttsData({
          ...producttsdata,
          data: result.data.results,
        });

        setNext(result.data.next);
        setPrev(result.data.previous);
      })
      .catch((err) => {
        showMessage(
          "Loading failed",
          "danger",
          "Loading error",
          "top",
          "top-right",
          0,
        );
      });
  };

  const handlePrev = () => {
    var config = {
      method: "get",
      url: prev.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };
    axios(config)
      .then(function (response) {
        setproducttsData({
          ...producttsdata,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {});
  };

  const handleNext = () => {
    var config = {
      method: "get",
      url: next.replace("http:", protocol.replace("//", "")),
      headers: {
        Authorization: getToken(),
      },
    };
    axios(config)
      .then(function (response) {
        setproducttsData({
          ...producttsdata,
          data: response.data.results,
        });
        setNext(response.data.next);
        setPrev(response.data.previous);
      })
      .catch(function (error) {
      });
  };

  const updateRestaurantCharge = () => {
    var rData = new FormData();
    rData.append("keyword", "restaurent_charge");
    rData.append("branch_id", data.id);
    rData.append("restaurent_charge", data.restaurent_charge);

    var config = {
      method: "patch",
      url: url + "/branch/details/",
      headers: {
        Authorization: getToken(),
      },
      data: rData,
    };

    axios(config)
      .then((response) => {
        if (response.data.Status === true) {
          clearRestaurantCache();
          showMessage(
            "Restaurant charge updated",
            "success",
            "Success!",
            "top",
            "top-right",
            0,
          );
        } else {
          showMessage("danger", "Error!", "top", "top-right", 0);
        }
      })
      .catch(() => {
        showMessage("Failed", "danger", "Error!", "top", "top-right", 0);
      });
  };

  const baseDeliveryCharge = () => {
    var rData = new FormData();
    rData.append("keyword", "base_delivery_charge");
    rData.append("branch_id", data.id);
    rData.append("base_delivery_charge", data.base_delivery_charge);

    var config = {
      method: "patch",
      url: url + "/branch/details/",
      headers: {
        Authorization: getToken(),
      },
      data: rData,
    };

    axios(config)
      .then(function (response) {
        if (response.data.Status === true) {
          clearRestaurantCache();
          showMessage(
            "Base Delivery charge updated",
            "success",
            "Success!",
            "top",
            "top-right",
            0,
          );
        } else {
          showMessage("danger", "Error!", "top", "top-right", 0);
        }
      })
      .catch(function (error) {
        showMessage("Failed", "danger", "Error!", "top", "top-right", 0);
      });
  };

  const gstCharge = () => {
    let rData = new FormData();
    rData.append("keyword", "gst_charge");
    rData.append("branch_id", data.id);
    rData.append("gst_charge", data.gst_charge);

    let config = {
      method: "patch",
      url: url + "/branch/details/",
      headers: {
        Authorization: getToken(),
      },
      data: rData,
    };

    axios(config)
      .then(function (response) {
        if (response.data.Status === true) {
          clearRestaurantCache();
          showMessage(
            "GST charge updated",
            "success",
            "Success!",
            "top",
            "top-right",
            0,
          );
        } else {
          showMessage("danger", "Error!", "top", "top-right", 0);
        }
      })
      .catch(function (error) {
        showMessage("Failed", "danger", "Error!", "top", "top-right", 0);
      });
  };

  const addExtraCommission = () => {
    let rData = new FormData();
    rData.append("keyword", "extra_commission");
    rData.append("branch_id", data.id);
    rData.append("extra_commission", data.extra_commission);

    let config = {
      method: "patch",
      url: url + "/branch/details/",
      headers: { Authorization: getToken() },
      data: rData,
    };

    axios(config)
      .then(function (response) {
        if (response.data.Status === true) {
          clearRestaurantCache();
          showMessage(
            "Restaurant extra commission updated",
            "success",
            "Success!",
            "top",
            "top-right",
            0,
          );
        } else {
          showMessage("danger", "Error!", "top", "top-right", 0);
        }
      })
      .catch(function (error) {
        showMessage("Failed", "danger", "Error!", "top", "top-right", 0);
      });
  };

  const [nodata, setnodata] = useState(false);
  const getData = () => {
    let res = ManageRestaurant("", "", "get", `id=${id}`);
    res.then((restaurantData) => {
      if (restaurantData.data && restaurantData.data.results.length) {
        localStorage.removeItem(
          `edit_restaurant_form_state_${restaurantData.data.results[0].id}`,
        );
        setData({
          ...data,
          id: restaurantData.data.results[0].id,
          name: restaurantData.data.results[0].name,
          branch_name: restaurantData.data.results[0].name,
          mobile: restaurantData.data.results[0].mobile,
          email: restaurantData.data.results[0].email,
          fssai: restaurantData.data.results[0].fssai_code,
          place: restaurantData.data.results[0].place,
          latitude: restaurantData.data.results[0].latitude,
          longitude: restaurantData.data.results[0].longitude,
          description: restaurantData.data.results[0].description,
          address: restaurantData.data.results[0].address,
          is_featured: restaurantData.data.results[0].is_featured,
          opening_time: restaurantData.data.results[0].opening_time,
          closing_time: restaurantData.data.results[0].closing_time,
          manager: restaurantData.data.results[0].manager,
          images: restaurantData.data.results[0].images,
          latestImage: restaurantData.data.results[0].images,
          admin_name: restaurantData.data.results[0].admin.first_name,
          admin_username: restaurantData.data.results[0].admin.username,
          admin_password: "",
          time_to_cook: restaurantData.data.results[0].time_to_cook,
          expence_meter: restaurantData.data.results[0].expence_meter,
          admin_id: restaurantData.data.results[0].admin.id,
          radius: restaurantData.data.results[0].radius,
          available_radius: restaurantData.data.results[0].available_radius,
          self_pickup: restaurantData.data.results[0].self_pickup,
          self_pickup_restaurent_charge:
            restaurantData.data.results[0].self_pickup_restaurent_charge ??
            "",
          pure_veg: restaurantData.data.results[0].pure_veg,
          is_celebration_store:
            restaurantData.data.results[0].is_celebration_store || false,
          is_cake_store: restaurantData.data.results[0].is_cake_store || false,
          free_delivery: restaurantData.data.results[0].free_delivery || false,
          admin_mobile:
            restaurantData.data.results[0].admin.details &&
            restaurantData.data.results[0].admin.details.mobile,

          is_block: restaurantData.data.results[0].is_blocked,
          is_closed: restaurantData.data.results[0].is_closed,

          restaurent_charge: restaurantData.data.results[0].restaurent_charge,
          base_delivery_charge:
            restaurantData.data.results[0].base_delivery_charge,
          gst_charge: restaurantData.data.results[0].gst_charge,
          extra_commission: restaurantData.data.results[0].extra_commission,
        });
        setCommission({
          ...commission,
          branch_id: restaurantData.data.results[0].id,
          commission: restaurantData.data.results[0].commission,
        });
        setBalance({
          ...balance,
          branch_id: restaurantData.data.results[0].id,
        });
        setLoading(false);
        setCoordObj({
          latitude: restaurantData.data.results[0].latitude,
          longitude: restaurantData.data.results[0].longitude,
          address: restaurantData.data.results[0].address,
        });
      } else {
        setnodata(true);
        setLoading(false);
      }
    });
  };
  const getApiKey = () => {
    let res = ManageSettingsAdmin(
      "",
      "",
      "get",
      "param_name=googlemap_key&keyword=super_admin_conf",
    );
    res.then((result) => {
      if (
        result?.data?.Message?.param_value &&
        result.data.Message.param_value !== "XXXXXXXXXXXXXX"
      ) {
        setapiKey(result.data.Message.param_value);
      } else {
        setapiKey(null);
      }
    });
  };

  const [errors, setErrors] = useState([]);

  const handleCoordinatesChange = (latt, longi) => {
    setCoordObj(prev => ({
      ...prev,
      latitude: latt,
      longitude: longi,
    }));

    var locToPlace = (lat, long) => {
      var url =
        "https://maps.googleapis.com/maps/api/geocode/json?latlng=" +
        lat +
        "," +
        long +
        `&key=${apiKey ? apiKey : googleApiKey}&sensor=true`;
      axios
        .get(url)
        .then(function (response) {
          if (response.data.results && response.data.results.length > 0) {
            setCoordObj(prev => ({
              ...prev,
              address: response.data.results[0].formatted_address,
            }));
          }
        })
        .catch(function (error) {});
    };
    locToPlace(latt, longi);
  };

  useEffect(() => {
    if (errors.length > 0) {
      showMessage(
        errors[0],
        "danger",
        "Following fields required!",
        "top",
        "top-right",
        0,
      );
    }
  }, [errors]);

  useEffect(() => {
  }, [apiKey]);

  return (
    <div className="content-body">
      <div className="container-fluid">
        {!loading ? (
          !nodata ? (
            <>
              <EditTopComponent
                swipe={swipe}
                page="Restaurant"
                ExtraButton={(e) => {
                  e.preventDefault();
                  setswipe((pre) => !pre);
                }}
                ExtraButtonName={swipe ? "Hide Products" : "Show Products"}
                DeleteButton={(e) => {
                  e.preventDefault();
                  confirmAlert({
                    customUI: ({ onClose }) => {
                      return (
                        <div
                          className="custom-ui"
                          style={{
                            borderRadius: 8,
                            border: "solid",
                            padding: 70,
                            borderWidth: 0.5,
                          }}
                        >
                          <h1>Are you sure?</h1>
                          <p>You want to delete ?</p>
                          <button
                            onClick={onClose}
                            className="btn btn-primary"
                            style={{ marginRight: 10 }}
                          >
                            Cancel
                          </button>
                          <button
                            onClick={() => {
                              let res = ManageRestaurant(
                                e,
                                "",
                                "delete",
                                `branch_id=${data.id}`,
                              );
                              res
                                .then((res) => {
                                  if (res.data.Status === true) {
                                    showMessage(
                                      "Delete success",
                                      "success",
                                      "Success!",
                                      "top",
                                      "top-right",
                                    );
                                    window.location.replace("/restaurants");
                                  } else {
                                    showMessage(
                                      res.data.Error,
                                      "danger",
                                      "Failed!",
                                      "top",
                                      "top-right",
                                    );
                                  }
                                })
                                .catch((err) => {
                                  showMessage(
                                    res.data.Error,
                                    "danger",
                                    "Error!",
                                    "top",
                                    "top-right",
                                  );
                                });
                            }}
                            className="btn btn-primary"
                          >
                            Delete
                          </button>
                        </div>
                      );
                    },
                  });
                }}
                CancelButton={(e) => {
                  e.preventDefault();
                  setEdit(false);
                }}
                EditButton={(e) => {
                  e.preventDefault();
                  setEdit(true);
                }}
                Edit={edit}
              />

              {swipe ? (
                <div className="container-fluid">
                  <FilterComponent
                    handleNext={handleNext}
                    handlePrev={handlePrev}
                    next={next}
                    prev={prev}
                    addItemName={"Add Products"}
                    addItemPath={`/addproducts?branch=${id}`}
                  />
                  <ProductsList
                    data={producttsdata.data}
                    toggle={(e, itemid, index) => {
                      setStock({ ...stock, out_of_stock: !e, item_id: itemid });

                      var x = { ...stock, out_of_stock: !e, item_id: itemid };
                      let result = ManageProducts(e, x, "patch", "");
                      result
                        .then((result) => {
                          if (result.data.Status === true) {
                            var newData = producttsdata.data;
                            var newObj = newData[index];
                            newObj = { ...newObj, is_out_of_stock: !e };
                            newData[index] = newObj;
                            setData({ ...producttsdata, data: newData });

                            setReload(!reload);
                          } else {
                            showMessage(
                              result.data.Error,
                              "danger",
                              "Error!",
                              "top",
                              "top-right",
                              0,
                            );
                          }
                        })
                        .catch((error) => {});
                    }}
                    toggleTempUnavailable={(e, itemid, index) => {
                      let x = {
                        keyword: "temporarily_unavailable",
                        temporarily_unavailable: !e,
                        item_id: itemid,
                      };
                      let result = ManageProducts(e, x, "patch", "");
                      result
                        .then((result) => {
                          if (result.data.Status === true) {
                            var newData = producttsdata.data;
                            var newObj = newData[index];
                            newObj = {
                              ...newObj,
                              is_temporarily_unavailable: !e,
                              unavailable_until: !e
                                ? getNext3amIST()
                                : null,
                            };
                            newData[index] = newObj;
                            setData({ ...producttsdata, data: newData });
                            showMessage(
                              "success",
                              "Product status updated successfully!",
                              "top",
                              "top-right",
                              1500,
                            );
                            setReload(!reload);
                          } else {
                            showMessage(
                              result.data.Error,
                              "danger",
                              "Error!",
                              "top",
                              "top-right",
                              0,
                            );
                          }
                        })
                        .catch((error) => {});
                    }}
                  />
                </div>
              ) : edit ? (
                <RestaurantEditForm
                  data={data}
                  setData={setData}
                  coordOb={coordOb}
                  setCoordObj={setCoordObj}
                  compression={compression}
                  setCompression={setCompression}
                  setEdit={setEdit}
                  setErrors={setErrors}
                  apiKey={apiKey}
                  handleCoordinatesChange={handleCoordinatesChange}
                  validateEmail={validateEmail}
                  ManageRestaurant={ManageRestaurant}
                  showMessage={showMessage}
                />
              ) : (
                data.id && (
                  <>
                    <div className="row">
                      <div className="col-lg-12">
                        <div className="profile card card-body px-3 pt-3 pb-0">
                          <div className="profile-head">
                            <div className="photo-content">
                              <div
                                className="cover-photo"
                                style={{
                                  borderRadius: 14,
                                  backgroundImage:
                                    data.images.length > 0 &&
                                    data.images[0].image,
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  color: "white",
                                  flexDirection: "column",
                                }}
                              >
                                <h3
                                  style={{
                                    display: "flex",
                                    color: "white",
                                    cursor: "pointer",
                                  }}
                                  title={`${data.id} : ${data.name}`}
                                >
                                  {data.name}
                                </h3>
                                <h6 style={{ display: "flex", color: "white" }}>
                                  {data.description}
                                </h6>
                              </div>
                            </div>
                            <div className="profile-info">
                              <div className="profile-photo">
                                <img
                                  src={
                                    data.images.length > 0 &&
                                    data.images[0].image
                                  }
                                  className="img-fluid rounded-circle"
                                  alt=""
                                  onError={handleImageError}
                                />
                              </div>
                              <div className="profile-details">
                                <div className="profile-name px-1 pt-1">
                                  {is_shop_admin ? (
                                    <>
                                      <a href={`/profile`}>
                                        <b className="text-primary mb-0">
                                          {data.admin_name}
                                        </b>
                                      </a>
                                      <a href={`/profile`}>
                                        <p className="text-primary mb-0">
                                          {data.admin_username}
                                        </p>
                                      </a>
                                      header
                                    </>
                                  ) : (
                                    <>
                                      <div>
                                        <b className="text-primary mb-0">
                                          {data.admin_name}
                                        </b>
                                      </div>
                                      <div>
                                        <p className="text-primary mb-0">
                                          {data.admin_username}
                                        </p>
                                      </div>
                                    </>
                                  )}
                                  <p>Admin</p>
                                </div>
                              </div>

                              <div className="profile-details">
                                <div className="profile-name px-2 pt-1">
                                  <a href="">
                                    <h4 className="text-primary mb-0">
                                      {formatTime(data.opening_time)}
                                    </h4>
                                  </a>
                                  <p>Opening Time</p>
                                </div>
                                <div className="profile-name px-2 pt-1 mr-1">
                                  <a href="">
                                    <h4 className="text-primary mb-0">
                                      {formatTime(data.closing_time)}
                                    </h4>
                                  </a>
                                  <p>Closing Time</p>
                                </div>

                                {(works_in_franchise ||
                                  is_shop_admin ||
                                  is_shop_manager) && (
                                  <div className="profile-name mt-2 mr-2">
                                    {works_in_franchise && (
                                      <a
                                        className="btn btn-primary"
                                        href={`/setting/${data.id}?of=restaurant`}
                                      >
                                        Settings
                                      </a>
                                    )}
                                    {(is_shop_admin || is_shop_manager) && (
                                      <a
                                        className="btn btn-primary"
                                        href={`/settings`}
                                      >
                                        Settings
                                      </a>
                                    )}
                                  </div>
                                )}

                                {/* Block restaurant functionality start */}
                                {works_in_franchise &&
                                  (data.is_block ? (
                                    <div className="profile-name mt-2">
                                      <div
                                        className="btn btn-primary"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          confirmAlert({
                                            customUI: ({ onClose }) => {
                                              return (
                                                <div
                                                  className="custom-ui"
                                                  style={{
                                                    borderRadius: 8,
                                                    border: "solid",
                                                    padding: 70,
                                                    borderWidth: 0.5,
                                                  }}
                                                >
                                                  <h1>Are you sure?</h1>
                                                  <p>You want to Unblock ?</p>
                                                  <button
                                                    onClick={onClose}
                                                    className="btn btn-primary"
                                                    style={{ marginRight: 10 }}
                                                  >
                                                    Cancel
                                                  </button>
                                                  <button
                                                    onClick={() => {
                                                      setData({
                                                        ...data,
                                                        is_block: false,
                                                      });
                                                      var data1 = {
                                                        ...data,
                                                        is_block: false,
                                                      };
                                                      let result = ManageBlock(
                                                        e,
                                                        data1,
                                                        "patch",
                                                        "",
                                                      );
                                                      result
                                                        .then((result) => {
                                                          if (
                                                            result.data
                                                              .Status === true
                                                          ) {
                                                            showMessage(
                                                              " Unblock success",
                                                              "success",
                                                              "Success!",
                                                              "top",
                                                              "top-right",
                                                            );
                                                            window.location.reload();
                                                          } else {
                                                            showMessage(
                                                              " Unblock failed",
                                                              "danger",
                                                              "Failed!",
                                                              "top",
                                                              "top-right",
                                                            );
                                                          }
                                                        })
                                                        .catch((err) => {
                                                          showMessage(
                                                            "failed",
                                                            "danger",
                                                            "Error!",
                                                            "top",
                                                            "top-right",
                                                          );
                                                        });
                                                    }}
                                                    className="btn btn-primary"
                                                  >
                                                    Unblock
                                                  </button>
                                                </div>
                                              );
                                            },
                                          });
                                        }}
                                      >
                                        Unblock
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="profile-name mt-2">
                                      <div
                                        className="btn btn-primary"
                                        onClick={(e) => {
                                          e.preventDefault();

                                          confirmAlert({
                                            customUI: ({ onClose }) => {
                                              return (
                                                <div
                                                  className="custom-ui"
                                                  style={{
                                                    borderRadius: 8,
                                                    border: "solid",
                                                    padding: 70,
                                                    borderWidth: 0.5,
                                                  }}
                                                >
                                                  <h1>Are you sure?</h1>
                                                  <p>You want to Block ?</p>
                                                  <button
                                                    onClick={onClose}
                                                    className="btn btn-primary"
                                                    style={{ marginRight: 10 }}
                                                  >
                                                    Cancel
                                                  </button>
                                                  <button
                                                    className="btn btn-primary"
                                                    onClick={() => {
                                                      setData({
                                                        ...data,
                                                        is_block: true,
                                                      });
                                                      var data1 = {
                                                        ...data,
                                                        is_block: true,
                                                      };
                                                      let result = ManageBlock(
                                                        e,
                                                        data1,
                                                        "patch",
                                                        "",
                                                      );
                                                      result
                                                        .then((result) => {
                                                          if (
                                                            result.data
                                                              .Status === true
                                                          ) {
                                                            showMessage(
                                                              " Block success",
                                                              "success",
                                                              "Success!",
                                                              "top",
                                                              "top-right",
                                                            );
                                                            window.location.reload();
                                                          } else {
                                                            showMessage(
                                                              " Block failed",
                                                              "danger",
                                                              "Failed!",
                                                              "top",
                                                              "top-right",
                                                            );
                                                            window.location.reload();
                                                          }
                                                        })
                                                        .catch((err) => {
                                                          showMessage(
                                                            err,
                                                            "danger",
                                                            "Error!",
                                                            "top",
                                                            "top-right",
                                                          );
                                                        });
                                                    }}
                                                  >
                                                    Block
                                                  </button>
                                                </div>
                                              );
                                            },
                                          });
                                        }}
                                      >
                                        Block
                                      </div>
                                    </div>
                                  ))}

                                {/* restaurant active/inactive functionality start */}
                                {works_in_franchise &&
                                  (data.is_closed ? (
                                    <div className="profile-name mt-2 ml-2">
                                      <div
                                        className="btn btn-primary"
                                        onClick={(e) => {
                                          e.preventDefault();

                                          confirmAlert({
                                            customUI: ({ onClose }) => {
                                              return (
                                                <div
                                                  className="custom-ui"
                                                  style={{
                                                    borderRadius: 8,
                                                    border: "solid",
                                                    padding: 70,
                                                    borderWidth: 0.5,
                                                  }}
                                                >
                                                  <h1>Are you sure?</h1>
                                                  <p>
                                                    Do you want to active
                                                    Restaurant?
                                                  </p>
                                                  <button
                                                    onClick={onClose}
                                                    className="btn btn-primary"
                                                    style={{ marginRight: 10 }}
                                                  >
                                                    Cancel
                                                  </button>
                                                  <button
                                                    className="btn btn-primary"
                                                    onClick={() => {
                                                      setData({
                                                        ...data,
                                                        is_closed: false,
                                                      });
                                                      var data1 = {
                                                        ...data,
                                                        is_closed: false,
                                                      };
                                                      let result = ManageActive(
                                                        e,
                                                        data1,
                                                        "patch",
                                                        "",
                                                      );
                                                      result
                                                        .then((result) => {
                                                          if (
                                                            result.data
                                                              .Status === true
                                                          ) {
                                                            showMessage(
                                                              "Restaurant active success",
                                                              "success",
                                                              "Success!",
                                                              "top",
                                                              "top-right",
                                                            );
                                                            window.location.reload();
                                                          } else {
                                                            showMessage(
                                                              "Restaurant active failed",
                                                              "danger",
                                                              "Failed!",
                                                              "top",
                                                              "top-right",
                                                            );
                                                            window.location.reload();
                                                          }
                                                        })
                                                        .catch((err) => {
                                                          showMessage(
                                                            err,
                                                            "danger",
                                                            "Error!",
                                                            "top",
                                                            "top-right",
                                                          );
                                                        });
                                                    }}
                                                  >
                                                    active
                                                  </button>
                                                </div>
                                              );
                                            },
                                          });
                                        }}
                                      >
                                        Closed
                                      </div>
                                    </div>
                                  ) : (
                                    <div className="profile-name mt-2 ml-2">
                                      <div
                                        className="btn"
                                        style={{
                                          background: "green",
                                          color: "white",
                                        }}
                                        onClick={(e) => {
                                          e.preventDefault();
                                          confirmAlert({
                                            customUI: ({ onClose }) => {
                                              return (
                                                <div
                                                  className="custom-ui"
                                                  style={{
                                                    borderRadius: 8,
                                                    border: "solid",
                                                    padding: 70,
                                                    borderWidth: 0.5,
                                                  }}
                                                >
                                                  <h1>Are you sure?</h1>
                                                  <p>
                                                    Do you want to close this
                                                    restaurant? Customers can't see
                                                    it until you make it active
                                                    again here. To close only for
                                                    today, the restaurant uses its
                                                    own app.
                                                  </p>
                                                  <button
                                                    onClick={onClose}
                                                    className="btn btn-primary"
                                                    style={{ marginRight: 10 }}
                                                  >
                                                    Cancel
                                                  </button>
                                                  <button
                                                    onClick={() => {
                                                      setData({
                                                        ...data,
                                                        is_closed: true,
                                                      });
                                                      var data1 = {
                                                        ...data,
                                                        is_closed: true,
                                                      };
                                                      let result = ManageActive(
                                                        e,
                                                        data1,
                                                        "patch",
                                                        "",
                                                      );
                                                      result
                                                        .then((result) => {
                                                          if (
                                                            result.data
                                                              .Status === true
                                                          ) {
                                                            showMessage(
                                                              "Restaurant closed",
                                                              "success",
                                                              "Success!",
                                                              "top",
                                                              "top-right",
                                                            );
                                                            window.location.reload();
                                                          } else {
                                                            showMessage(
                                                              "Could not close the restaurant",
                                                              "danger",
                                                              "Failed!",
                                                              "top",
                                                              "top-right",
                                                            );
                                                            window.location.reload();
                                                          }
                                                        })
                                                        .catch((err) => {
                                                          showMessage(
                                                            "failed",
                                                            "danger",
                                                            "Error!",
                                                            "top",
                                                            "top-right",
                                                          );
                                                        });
                                                    }}
                                                    className="btn btn-primary"
                                                  >
                                                    Yes
                                                  </button>
                                                </div>
                                              );
                                            },
                                          });
                                        }}
                                      >
                                        Active
                                      </div>
                                    </div>
                                  ))}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="row">
                      <div className="col-xl-6">
                        <RestaurantChargesSection
                          data={data}
                          setData={setData}
                          commission={commission}
                          setCommission={setCommission}
                          updateRestaurantCharge={updateRestaurantCharge}
                          baseDeliveryCharge={baseDeliveryCharge}
                          gstCharge={gstCharge}
                          addExtraCommission={addExtraCommission}
                          ManageRestaurant={ManageRestaurant}
                          showMessage={showMessage}
                        />

                        {false && (
                          <RestaurantWalletCard
                            balanceAmount={balanceAmount}
                            balance={balance}
                            setBalance={setBalance}
                            data={data}
                            ManageBalanceAmount={ManageBalanceAmount}
                            showMessage={showMessage}
                          />
                        )}
                      </div>

                      <RestaurantStatsCard
                        data={data}
                        is_shop_admin={is_shop_admin}
                        is_shop_manager={is_shop_manager}
                      >
                        <RestaurantGallery
                          data={data}
                          ManageRestaurantImage={ManageRestaurantImage}
                          showMessage={showMessage}
                        />
                      </RestaurantStatsCard>
                    </div>

                    <RestaurantOrderHistory
                      filter={filter}
                      setfilter={setfilter}
                      basis={basis}
                      setBasis={setBasis}
                      reportNext={reportNext}
                      reportPrev={reportPrev}
                      branchAmounts={branchAmounts}
                      orderReportSummary={orderReportSummary}
                      handleReportNext={handleReportNext}
                      handleReportPrev={handleReportPrev}
                      getOrderReportSummary={getOrderReportSummary}
                      getWallet={getWallet}
                      showMessage={showMessage}
                    />
                  </>
                )
              )}
            </>
          ) : (
            <NoDataComponent data="Restaurant" />
          )
        ) : (
          <LoadingComponent />
        )}
      </div>
    </div>
  );
}

function Restaurant() {
  const headers = "Restaurant Details";
  let { id } = useParams();

  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={headers} />
        <NavBar />
        <Body restaurant={id} />
        <Footer />
      </div>
    </div>
  );
}

export default Restaurant;
